import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
/** @typedef {object} RoutesAdminContactRelationshipsRouteProps */

/** @typedef {object} RoutesAdminContactRelationshipsRouteState */

/**
 * @extends {ShapeComponent<RoutesAdminContactRelationshipsRouteProps, RoutesAdminContactRelationshipsRouteState>}
 */
class RoutesAdminContactRelationshipsRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="contact-relationships">
        <Route component="edit" exact path="new" />
        <Route exact path=":contact_relationship_id/edit" />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}

export default memo(shapeComponent(RoutesAdminContactRelationshipsRoute))
